import { StyleSheet, useWindowDimensions } from "react-native";

import { isWeb, sendEmail } from "@stepapp/core";
import { Block, Button, Divider, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { useContactDetails } from "../../src/hooks";
import { AppStorage } from "../../src/services/AppStorage";
import { useDisplayIntercom } from "../../src/services/Intercom";

const Support = () => {
  const countryCode = AppStorage().get("countryCode");
  const { t } = useTranslation();
  const displayIntercom = useDisplayIntercom(countryCode);
  const { width: screenWidth } = useWindowDimensions();

  const { Email } = useContactDetails();

  const smallDevice = screenWidth <= 360;

  return (
    <Block paddingTop={isWeb ? 4 : 2}>
      <Typography variant="newH2">{t("screens.support.title")}</Typography>

      <Block paddingTop={3.5}>
        <Typography variant="sectionTitle">{t("screens.support.contactOptions")}</Typography>

        <Block
          marginBottom={2}
          marginTop={4}
          paddingHorizontal={2}
          paddingVertical={2}
          style={styles.sectionContainer}
        >
          <Block alignCenter justifySpace row={!smallDevice}>
            <Block row flex={smallDevice ? 0 : 1} paddingBottom={smallDevice ? 1 : 0}>
              <SvgIcon name="envelope" size={22} style={styles.icon} />
              <Typography>{Email}</Typography>
            </Block>

            <Button
              label={t("screens.support.sendEmail")}
              onPress={() => sendEmail(Email)}
              type="primary"
              variant="small"
            />
          </Block>
        </Block>

        <Divider separator={t("common.or")} />

        <Block paddingTop={2}>
          <Button
            label={t("screens.support.startChat")}
            onPress={() => displayIntercom()}
            type="primary"
          />
        </Block>
      </Block>
    </Block>
  );
};

export default Support;

const styles = StyleSheet.create({
  icon: {
    marginRight: spacing.unit,
    justifyContent: "center",
  },
  sectionContainer: {
    backgroundColor: palette.secondary.main,
    borderRadius: spacing.radius * 2,
  },
});
